<template>
  <div
    v-if="isSlot"
    @click="$emit('click')"
    :class="{
      select: select,
      disabled: disabled,
    }"
    class="btn-spec"
  >
    <slot name="content"></slot>
  </div>
  <div
    v-else
    @click="$emit('click')"
    :class="{
      select: select,
      disabled: disabled,
    }"
    class="btn-spec"
  >
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    customClass() {
      if (this.disabled) {
        return 'btn-spec disabled'
      } else if (this.select) {
        return 'btn-spec select'
      }
      return 'btn-spec'
    },
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    select: {
      type: Boolean,
      default: false,
    },

    isSlot: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>

.btn-spec
    border: 1px solid $color-bnn-gray-light
    border-radius: 8px;
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    padding: 0.5rem 0
    font-weight: bold
    text-align: center
    @media small
      background: white
    &:hover
        cursor pointer

.btn-spec.disabled
     // cursor: not-allowed
     opacity: 0.5
     color: $color-bnn-gray-medium

.btn-spec.select
     border: 1px solid $color-border-btn-spec;
</style>
